import { CALENDER_LINK_CHRISTINE as CALENDER_LINK } from 'sly/b2b/constants';
import { eventNames, useEvents } from 'sly/services/events';

export default function HeaderBanner() {
  const { events } = useEvents();
  const handleClick = () => {
    if (location)
      events.track(eventNames.ButtonClicked, {
        text: 'Schedule call in header',
        location: 'B2B senior-adjacent industries',
      });
    window.open(CALENDER_LINK, '_blank');
  };
  return (
    <header className='provider-gradiant m-4 flex flex-col items-center rounded-xl py-12 px-6 md:p-0'>
      <div className='flex flex-col items-center justify-end gap-4 md:max-w-5xl md:p-20'>
        <div className='flex flex-col items-center justify-end gap-4 md:w-[680px]'>
          <div className='flex self-stretch sm:justify-center '>
            <section className='font-t-xxl text-center sm:w-[600px]'>
              Unlock opportunity in your senior audience
            </section>
          </div>
          <section className='font-b-l text-center'>
            Seniorly empowers a wide range of industries that work with older
            adults and their families to deliver guidance and support for senior
            living. We partner with insurance, real estate, financial advising
            and more to unlock the value of senior living expertise.
          </section>
          <hr />
        </div>
        <button
          className='provider-cta self-stretch sm:self-auto'
          onClick={handleClick}
        >
          <p className='font-t-m-azo-xs text-white'>Schedule a call</p>
        </button>
      </div>
    </header>
  );
}
